var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: _vm.animationObject,
          expression: "animationObject",
        },
      ],
      staticClass: "automation-insights",
    },
    [
      _c(
        "div",
        { staticClass: "insights-container" },
        [
          _c("div", { staticClass: "header-container" }, [
            _c("div", { staticClass: "title" }, [_vm._v("İstatistikler")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-container" },
              [
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("a-tooltip", { attrs: { title: "Tarih Aralığı" } }, [
                      _c("i", { staticClass: "material-icons filter-icon" }, [
                        _vm._v("date_range"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-range-picker", {
                      staticStyle: { width: "220px" },
                      attrs: {
                        format: "DD/MM/YYYY",
                        placeholder: ["Başlangıç", "Bitiş"],
                        ranges: {
                          "Son Hafta": [
                            _vm.moment().subtract(7, "days"),
                            _vm.moment(),
                          ],
                          "Son Ay": [
                            _vm.moment().subtract(30, "days"),
                            _vm.moment(),
                          ],
                          "Son 3 Ay": [
                            _vm.moment().subtract(90, "days"),
                            _vm.moment(),
                          ],
                        },
                      },
                      on: { change: _vm.handleDateChange },
                      model: {
                        value: _vm.filters.dateRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "dateRange", $$v)
                        },
                        expression: "filters.dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("a-tooltip", { attrs: { title: "Durum Filtresi" } }, [
                      _c("i", { staticClass: "material-icons filter-icon" }, [
                        _vm._v("filter_list"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "220px" },
                        attrs: {
                          mode: "multiple",
                          placeholder: "Durum Filtresi",
                        },
                        on: { change: _vm.handleStatusChange },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { attrs: { value: "scheduled" } },
                          [
                            _c("div", { staticClass: "status-option" }, [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "material-icons status-icon scheduled",
                                },
                                [_vm._v("schedule")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Planlanmış")]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "running" } }, [
                          _c("div", { staticClass: "status-option" }, [
                            _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons status-icon running",
                              },
                              [_vm._v("play_arrow")]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Çalışıyor")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "waiting-reply" } },
                          [
                            _c("div", { staticClass: "status-option" }, [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "material-icons status-icon waiting",
                                },
                                [_vm._v("hourglass_empty")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Yanıt Bekliyor")]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "done" } }, [
                          _c("div", { staticClass: "status-option" }, [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons status-icon done",
                              },
                              [_vm._v("check_circle")]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Tamamlandı")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "failed" } }, [
                          _c("div", { staticClass: "status-option" }, [
                            _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons status-icon failed",
                              },
                              [_vm._v("error")]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Başarısız")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "cancelled" } },
                          [
                            _c("div", { staticClass: "status-option" }, [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "material-icons status-icon cancelled",
                                },
                                [_vm._v("cancel")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("İptal Edildi")]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasActiveFilters()
                  ? _c(
                      "a-tooltip",
                      { attrs: { title: "Filtreleri Temizle" } },
                      [
                        _c("SupsisButton", {
                          attrs: { icon: "clear_all" },
                          on: { click: _vm.clearAllFilters },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  { attrs: { title: "Verileri Yenile" } },
                  [
                    _c("SupsisButton", {
                      attrs: { primary: "", icon: "refresh" },
                      on: { click: _vm.refreshData },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.hasActiveFilters()
            ? _c("div", { staticClass: "active-filters-bar" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "active-filters-tags" },
                  [
                    _vm.hasDateFilter()
                      ? _c(
                          "a-tag",
                          {
                            attrs: { closable: "", color: "green" },
                            on: { close: _vm.clearDateFilter },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("date_range"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.formatDateRange()))]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filters.status, function (status) {
                      return _c(
                        "a-tag",
                        {
                          key: status,
                          attrs: {
                            closable: "",
                            color: _vm.getStatusColor(status),
                          },
                          on: {
                            close: function () {
                              return _vm.removeStatus(status)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(_vm.getStatusIcon(status))),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.getStatusName(status))),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c(
                "div",
                { staticClass: "stats-cards" },
                [
                  _c(
                    "a-card",
                    {
                      staticClass: "stats-card",
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "card-title" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("task_alt"),
                                ]),
                                _vm._v(
                                  "\n                            Toplam Görevler\n                        "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "number" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(_vm.insightData.stats.totalTasks)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v("Yürütülen Görevler"),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-card",
                    {
                      staticClass: "stats-card",
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "card-title" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("horizontal_rule"),
                                ]),
                                _vm._v(
                                  "\n                            Başarı Oranı\n                        "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "number" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatPercentage(
                                _vm.insightData.stats.successRate
                              )
                            ) + "%"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v("Başarılı Görevler"),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-card",
                    {
                      staticClass: "stats-card",
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "card-title" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("timer"),
                                ]),
                                _vm._v(
                                  "\n                            Ortalama Süre\n                        "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "number" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatDuration(
                                _vm.insightData.stats.avgDuration
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v("Ortalama Çalışma Süresi"),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-card",
                    {
                      staticClass: "stats-card",
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "card-title" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("pending"),
                                ]),
                                _vm._v(
                                  "\n                            Aktif Görevler\n                        "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "number" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(
                                _vm.insightData.stats.totalRunningTasks
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v("Şu Anda Çalışıyor"),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chart-container" },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            {
                              staticClass: "chart-card",
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "card-title" }, [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("timeline")]
                                        ),
                                        _vm._v(
                                          "\n                                    Günlük Görev Çalıştırma\n                                "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "chart" },
                                [
                                  _c("v-chart", {
                                    attrs: {
                                      options: _vm.dailyTasksOptions,
                                      autoresize: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            {
                              staticClass: "chart-card",
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "card-title" }, [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("pie_chart")]
                                        ),
                                        _vm._v(
                                          "\n                                    Durum Dağılımı\n                                "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "chart" },
                                [
                                  _c("v-chart", {
                                    attrs: {
                                      options: _vm.statusDistributionOptions,
                                      autoresize: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chart-container" },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            {
                              staticClass: "chart-card",
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "card-title" }, [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("timer")]
                                        ),
                                        _vm._v(
                                          "\n                                    Süre Dağılımı\n                                "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "chart" },
                                [
                                  _c("v-chart", {
                                    attrs: {
                                      options: _vm.durationDistributionOptions,
                                      autoresize: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-card",
                            {
                              staticClass: "chart-card",
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "card-title" }, [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("error_outline")]
                                        ),
                                        _vm._v(
                                          "\n                                    Sonlandırma Nedenleri\n                                "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "chart" },
                                [
                                  _c("v-chart", {
                                    attrs: {
                                      options: _vm.terminateReasonsOptions,
                                      autoresize: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-card",
                {
                  staticClass: "data-table-card",
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "card-title" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("leaderboard"),
                            ]),
                            _vm._v(
                              "\n                        Otomasyon Performansı\n                    "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("a-table", {
                    attrs: {
                      columns: _vm.automationPerformanceColumns,
                      "data-source": _vm.automationPerformanceData,
                      pagination: { pageSize: 5 },
                      rowKey: function (record) {
                        return record.automationId
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (ref) {
                          var record = ref.record
                          return [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewAutomationDetails(
                                      record.automationId
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Görüntüle\n                        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "active-filter-info" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("filter_alt")]),
      _vm._v(" "),
      _c("span", [_vm._v("Aktif Filtreler:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }